import { PureComponent } from 'react';
import styled from 'styled-components';
import ThemeConfigContext from '../../theming/contexts/ThemeConfigContext';
import ThemeContext from '../../theming/contexts/ThemeContext';
import ThemeProvider from '../../theming/providers/ThemeProvider';
import { PrimaryMessageAvatarWrapper } from './PrimaryMessageAvatar';
import { PrimaryMessageContentWrapper } from './PrimaryMessageContent';
import { PrimaryMessageFooterWrapper } from './PrimaryMessageFooter';
import { MESSAGE_AVATAR_OFFSET_PX, MESSAGE_MIN_WIDTH_PX } from './messageDimensions';
import { PrimaryMessageHeaderWrapper } from './PrimaryMessageHeader';
import { PrimaryMessageHeaderContentWrapper } from './PrimaryMessageHeaderContent';
import { jsx as _jsx } from "react/jsx-runtime";
const AVATAR_MARGIN = '8px';
const PrimaryMessageWrapper = styled.div.withConfig({
  displayName: "PrimaryMessage__PrimaryMessageWrapper"
})(["display:flex;flex-direction:column;align-items:", ";padding-left:", ";", "{", "{width:", ";margin-left:-", ";margin-right:", ";}>:first-child{&", "{margin-left:", ";}}}", "{margin-left:", ";}", "{margin-left:", ";width:max( calc(100% - ", "px),", "px );}"], ({
  alignment
}) => alignment || 'flex-start', AVATAR_MARGIN, PrimaryMessageHeaderWrapper, PrimaryMessageAvatarWrapper, ({
  avatarWidth
}) => avatarWidth, AVATAR_MARGIN, AVATAR_MARGIN, PrimaryMessageHeaderContentWrapper, ({
  avatarWidth
}) => avatarWidth, PrimaryMessageContentWrapper, ({
  avatarWidth
}) => avatarWidth, PrimaryMessageFooterWrapper, ({
  avatarWidth
}) => avatarWidth, MESSAGE_AVATAR_OFFSET_PX, MESSAGE_MIN_WIDTH_PX);
const SpacingWrapper = styled.div.withConfig({
  displayName: "PrimaryMessage__SpacingWrapper"
})(["padding-top:4px;padding-bottom:4px;padding-left:10px;padding-right:10px;width:100%;"]);
export default class PrimaryMessage extends PureComponent {
  render() {
    const {
      children,
      className,
      use
    } = this.props;
    return children ? /*#__PURE__*/_jsx(ThemeProvider, {
      themeConfig: this.context,
      use: use,
      children: /*#__PURE__*/_jsx(SpacingWrapper, {
        className: className,
        children: /*#__PURE__*/_jsx(ThemeContext.Consumer, {
          children: ({
            alignItems,
            avatarWidth
          }) => /*#__PURE__*/_jsx(PrimaryMessageWrapper, {
            "data-test-id": this.props['data-test-id'],
            "data-test-use": use,
            alignment: alignItems,
            avatarWidth: avatarWidth,
            children: children
          })
        })
      })
    }) : null;
  }
}
PrimaryMessage.displayName = 'PrimaryMessage';
PrimaryMessage.contextType = ThemeConfigContext;